import AuthService from '../services/AuthService';

const RenderOnRoles: React.FC<Props> = ({ roles, children }): any  => (AuthService.hasRole(roles)) ? children : null;

interface Props {
  roles: string[],
}

export default RenderOnRoles